import styled from 'styled-components';
import React, { useContext, useEffect } from 'react';
import { StageContext } from '../../hooks/StageContext';
import { useServicesContext } from '@oneaudi/vtp-shared';
import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';

const AvpWebStreamWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  background: white;
`;

export const AvpWebstreamWrapper: React.FC<{ prString?: string; configId?: string }> = ({
  prString,
  configId,
}) => {
  if (!prString || !configId) return null;

  const { setWebstreamLayerOpen, setWebstreamScriptLoading } = useContext(StageContext);

  const localeService = useServicesContext().getAdditionalService(
    'gfa:locale-service'
  ) as LocaleServiceV1;

  useEffect(() => {
    // AVP EVENT HANDLING
    const onConnected = () => {
      setWebstreamScriptLoading(false);
    };

    const onUpdate = (evt: { detail: { active: boolean } }) => {
      const activeState = evt.detail.active;
      if (!activeState) {
        setWebstreamLayerOpen(false);
      }
    };

    const onException = () => {
      setWebstreamScriptLoading(false);
    };

    // @ts-ignore
    // AVP Component emits update event when opened or closed
    window.removeEventListener('update:active', onUpdate);
    // @ts-ignore
    window.addEventListener('update:active', onUpdate);

    // AVP Component emits connected when initial connection to streaming server is established
    window.removeEventListener('connected', onConnected);
    window.addEventListener('connected', onConnected);

    // Error Handling
    window.addEventListener('exception', onException);
    return () => {
      window.removeEventListener('connected', onConnected);
      // @ts-ignore
      window.removeEventListener('update:active', onUpdate);
      window.removeEventListener('exception', onException);
    };
  }, []);

  return (
    <AvpWebStreamWrapper data-testid="avp-webstream-container">
      {/* @ts-ignore */}
      <avp-3dws-deck
        config-id={configId}
        active
        pr-string={prString}
        market={localeService?.market}
      />
    </AvpWebStreamWrapper>
  );
};
